import { ErrorInfo } from "react";
import { isDevEnvironment } from "./utils";

const sendErrorToSentry = async (error: Error) => {
  const Sentry = await import("@sentry/browser");

  Sentry.init({
    dsn: "https://53329d23ae5d4d9cb75f49d34a5c374e@sentry.io/1268067",
    enabled: !isDevEnvironment,
    ignoreErrors: [
      // TODO: find a better way to exclude this error
      "Request failed with status code 401",
    ],
    beforeSend: (event) => {
      const exception = event.exception?.values?.[0];
      if (!exception) return event;

      // Filter out an error that occurs with lazysizes in combination with
      // the Facebook browser on iOS. See https://github.com/aFarkas/lazysizes/issues/520
      const isLazySizesFBError =
        exception.value === "Illegal invocation" &&
        location.search.indexOf("fbclid=") !== -1;

      return isLazySizesFBError ? null : event;
    },
  });

  Sentry.captureException(error);
};

export const registerErrorReporting = () => {
  const onFirstError = (event: ErrorEvent) => {
    sendErrorToSentry(event.error);
    window.removeEventListener("error", onFirstError);
  };

  window.addEventListener("error", onFirstError);
};

export const trackErrorWithService = (error: Error, errorInfo?: ErrorInfo) => {
  console.error(error, errorInfo);
  sendErrorToSentry(error);
};
